import { Switch } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";

const PaywallSwitch = ({
	adminPaywallEnabled,
	toggleAdminPaywall,
}: {
	adminPaywallEnabled: boolean;
	toggleAdminPaywall: () => void;
}) => {
	const theme = useAppTheme();
	return (
		<Switch
			value={adminPaywallEnabled}
			onValueChange={toggleAdminPaywall}
			color={theme.colors.secondary}
			aria-checked={adminPaywallEnabled}
			aria-label="Admin paywall preview switch"
		/>
	);
};

export default PaywallSwitch;
